// Generated by scripts/build-site.mjs from library.md. Do not edit.

export const badgeCatalog = {
    "generatedFrom": "library.md",
    "layoutCount": 81,
    "badgeCount": 500,
    "categoryCount": 11,
    "categories": [
        "GitHub-hosted projects",
        "External CI and code quality",
        "JavaScript and TypeScript",
        "Language-first repositories",
        "Containers, infrastructure, and unsupported registries",
        "Language package registries",
        "Editor and browser extensions",
        "Operating-system distribution",
        "Community and custom metadata",
        "Alternative and provider-native services",
        "Conditional badges: preview before keeping"
    ],
    "languageCount": 45,
    "languages": [
        "Language agnostic",
        "Bash",
        "C",
        "C#",
        "C++",
        "Clojure",
        "Crystal",
        "D",
        "Dart",
        "Dockerfile",
        "Elixir",
        "Elm",
        "Emacs Lisp",
        "Erlang",
        "F#",
        "Fish",
        "Go",
        "Groovy",
        "Haskell",
        "Haxe",
        "HCL",
        "Java",
        "JavaScript",
        "Julia",
        "Kotlin",
        "Lua",
        "Nim",
        "Objective-C",
        "OCaml",
        "Perl",
        "PHP",
        "PowerShell",
        "Python",
        "R",
        "Ruby",
        "Rust",
        "Scala",
        "Shell",
        "Swift",
        "TeX",
        "TypeScript",
        "Visual Basic .NET",
        "YAML",
        "Zig",
        "Zsh"
    ],
    "providerCount": 10,
    "providers": [
        {
            "deliveryHosts": [],
            "documentation": "https://badgen.net/",
            "homepage": "https://badgen.net/",
            "id": "badgen",
            "imageHosts": [
                "flat.badgen.net",
                "badgen.net"
            ],
            "name": "Badgen",
            "sampleUrl": "https://flat.badgen.net/static/status/ok/047857",
            "badgeCount": 454,
            "layoutCount": 73
        },
        {
            "deliveryHosts": [],
            "documentation": "https://shields.io/docs/",
            "homepage": "https://shields.io/",
            "id": "shields",
            "imageHosts": [
                "img.shields.io"
            ],
            "name": "Shields.io",
            "sampleUrl": "https://img.shields.io/badge/status-ok-047857",
            "badgeCount": 18,
            "layoutCount": 4
        },
        {
            "deliveryHosts": [
                "d25lcipzij17d.cloudfront.net"
            ],
            "documentation": "https://badge.fury.io/",
            "homepage": "https://badge.fury.io/",
            "id": "badge-fury",
            "imageHosts": [
                "badge.fury.io"
            ],
            "name": "Badge Fury",
            "sampleUrl": "https://badge.fury.io/js/express.svg",
            "badgeCount": 2,
            "layoutCount": 2
        },
        {
            "deliveryHosts": [],
            "documentation": "https://docs.codecov.com/docs/status-badges",
            "homepage": "https://about.codecov.io/",
            "id": "codecov",
            "imageHosts": [
                "codecov.io"
            ],
            "name": "Codecov",
            "sampleUrl": "https://codecov.io/gh/codecov/codecov-action/graph/badge.svg",
            "badgeCount": 3,
            "layoutCount": 3
        },
        {
            "deliveryHosts": [],
            "documentation": "https://docs.snyk.io/",
            "homepage": "https://snyk.io/",
            "id": "snyk",
            "imageHosts": [
                "snyk.io"
            ],
            "name": "Snyk",
            "sampleUrl": "https://snyk.io/test/github/snyk/snyk-go-parser/badge.svg",
            "badgeCount": 3,
            "layoutCount": 3
        },
        {
            "deliveryHosts": [
                "img.shields.io"
            ],
            "documentation": "https://badgesize.com/Usage",
            "homepage": "https://badgesize.com/",
            "id": "badge-size",
            "imageHosts": [
                "img.badgesize.com"
            ],
            "name": "BadgeSize",
            "sampleUrl": "https://img.badgesize.com/nevware21/badgesize/main/README.md?compression=gzip",
            "badgeCount": 3,
            "layoutCount": 2
        },
        {
            "deliveryHosts": [],
            "documentation": "https://dependents.info/",
            "homepage": "https://dependents.info/",
            "id": "dependents-info",
            "imageHosts": [
                "dependents.info"
            ],
            "name": "dependents.info",
            "sampleUrl": "https://dependents.info/gouravkhunger/dependents.info/badge",
            "badgeCount": 3,
            "layoutCount": 3
        },
        {
            "deliveryHosts": [],
            "documentation": "https://shieldcn.dev/docs/api-reference",
            "homepage": "https://shieldcn.dev/",
            "id": "shieldcn",
            "imageHosts": [
                "shieldcn.dev"
            ],
            "name": "shieldcn",
            "sampleUrl": "https://shieldcn.dev/github/jal-co/shieldcn/stars.svg",
            "badgeCount": 10,
            "layoutCount": 2
        },
        {
            "deliveryHosts": [],
            "documentation": "https://nodei.co/",
            "homepage": "https://nodei.co/",
            "id": "nodeico",
            "imageHosts": [
                "nodei.co"
            ],
            "name": "NodeICO",
            "sampleUrl": "https://nodei.co/npm/express.svg?style=flat&data=n,v,d",
            "badgeCount": 1,
            "layoutCount": 1
        },
        {
            "deliveryHosts": [],
            "documentation": "https://github.com/pavi2410/PlayBadges#usage",
            "homepage": "https://playbadges.pavi2410.com/",
            "id": "playbadges",
            "imageHosts": [
                "playbadges.pavi2410.com",
                "playbadges.pavi2410.me"
            ],
            "name": "PlayBadges",
            "sampleUrl": "https://playbadges.pavi2410.com/badge/downloads?id=appinventor.ai_pavitragolchha.VR&pretty",
            "badgeCount": 3,
            "layoutCount": 1
        }
    ],
    "entries": [
        {
            "id": "github-hosted-projects-balanced-public-repository",
            "category": "GitHub-hosted projects",
            "title": "Balanced public repository",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 73,
            "template": "[![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub forks.](https://flat.badgen.net/github/forks/OWNER/REPO?color=C2410C)](https://github.com/OWNER/REPO/forks) [![GitHub contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=7E22CE)](https://github.com/OWNER/REPO/graphs/contributors) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "github-hosted-projects-release-driven-binary-or-desktop-app",
            "category": "GitHub-hosted projects",
            "title": "Release-driven binary or desktop app",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 81,
            "template": "[![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Latest release asset downloads.](https://flat.badgen.net/github/assets-dl/OWNER/REPO?color=BE185D)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Last GitHub commit.](https://flat.badgen.net/github/last-commit/OWNER/REPO/BRANCH?color=475569)](https://github.com/OWNER/REPO/commits/BRANCH) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "github-hosted-projects-github-action",
            "category": "GitHub-hosted projects",
            "title": "GitHub Action",
            "description": "Replace ACTION_SLUG with the Marketplace action slug. Keep the checks badge dynamic so a broken action does not advertise itself as passing.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 89,
            "template": "[![Project type: GitHub Action.](https://flat.badgen.net/static/type/GitHub%20Action/6D28D9)](https://github.com/marketplace/actions/ACTION_SLUG) [![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "ACTION_SLUG",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "github-hosted-projects-documentation-site-or-static-site",
            "category": "GitHub-hosted projects",
            "title": "Documentation site or static site",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 99,
            "template": "[![Site deployment checks.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Last content update.](https://flat.badgen.net/github/last-commit/OWNER/REPO/BRANCH?color=475569)](https://github.com/OWNER/REPO/commits/BRANCH) [![Documentation contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=7E22CE)](https://github.com/OWNER/REPO/graphs/contributors) [![Open documentation issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![Documentation license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "github-hosted-projects-monorepo",
            "category": "GitHub-hosted projects",
            "title": "Monorepo",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 107,
            "template": "[![Latest stable monorepo release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Monorepo checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=7E22CE)](https://github.com/OWNER/REPO/graphs/contributors) [![GitHub open pull requests.](https://flat.badgen.net/github/open-prs/OWNER/REPO?color=0369A1)](https://github.com/OWNER/REPO/pulls) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![Repository dependents.](https://flat.badgen.net/github/dependents-repo/OWNER/REPO?color=0F766E)](https://github.com/OWNER/REPO/network/dependents) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "github-hosted-projects-api-bot-or-hosted-service",
            "category": "GitHub-hosted projects",
            "title": "API, bot, or hosted service",
            "description": "UptimeRobot badges require a monitor-specific read-only key. The key is meant to identify that public monitor; never put an account-wide API key in a README.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 115,
            "template": "[![Latest stable service release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Service checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Current service status.](https://flat.badgen.net/uptime-robot/status/UPTIME_ROBOT_MONITOR_KEY)](https://status.example.com) [![Service uptime over the past month.](https://flat.badgen.net/uptime-robot/month/UPTIME_ROBOT_MONITOR_KEY)](https://status.example.com) [![Latest service response time.](https://flat.badgen.net/uptime-robot/response/UPTIME_ROBOT_MONITOR_KEY)](https://status.example.com) [![Open service issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH",
                "UPTIME_ROBOT_MONITOR_KEY"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "github-hosted-projects-community-funded-open-source",
            "category": "GitHub-hosted projects",
            "title": "Community-funded open source",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 125,
            "template": "[![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=7E22CE)](https://github.com/OWNER/REPO/graphs/contributors) [![Open Collective backers.](https://flat.badgen.net/opencollective/backers/COLLECTIVE?color=BE185D)](https://opencollective.com/COLLECTIVE) [![Open Collective balance.](https://flat.badgen.net/opencollective/balance/COLLECTIVE?color=047857)](https://opencollective.com/COLLECTIVE) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "COLLECTIVE",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "github-hosted-projects-security-and-quality-focused-project",
            "category": "GitHub-hosted projects",
            "title": "Security- and quality-focused project",
            "description": "Use the Snyk badge only if the project is actually monitored by Snyk. Replace SNYK_ORG and SNYK_PROJECT_ID so the click opens the exact report rather than a generic security landing page.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 133,
            "template": "[![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![Snyk vulnerability status.](https://flat.badgen.net/snyk/OWNER/REPO/BRANCH)](https://app.snyk.io/org/SNYK_ORG/project/SNYK_PROJECT_ID) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH",
                "SNYK_ORG",
                "SNYK_PROJECT_ID"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "github-hosted-projects-gitlab-project",
            "category": "GitHub-hosted projects",
            "title": "GitLab project",
            "description": "Badgen's GitLab release and license integrations currently return upstream errors for some live projects, so this row deliberately uses the healthy social and contribution endpoints.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 143,
            "template": "[![GitLab stars.](https://flat.badgen.net/gitlab/stars/GITLAB_NAMESPACE/REPO?color=B45309)](https://gitlab.com/GITLAB_NAMESPACE/REPO/-/starrers) [![GitLab forks.](https://flat.badgen.net/gitlab/forks/GITLAB_NAMESPACE/REPO?color=C2410C)](https://gitlab.com/GITLAB_NAMESPACE/REPO/-/forks) [![GitLab open issues.](https://flat.badgen.net/gitlab/open-issues/GITLAB_NAMESPACE/REPO?color=B91C1C)](https://gitlab.com/GITLAB_NAMESPACE/REPO/-/issues) [![GitLab merged merge requests.](https://flat.badgen.net/gitlab/merged-mrs/GITLAB_NAMESPACE/REPO?color=0F766E)](https://gitlab.com/GITLAB_NAMESPACE/REPO/-/merge_requests?scope=all&state=merged) [![GitLab contributors.](https://flat.badgen.net/gitlab/contributors/GITLAB_NAMESPACE/REPO?color=7E22CE)](https://gitlab.com/GITLAB_NAMESPACE/REPO/-/graphs/BRANCH)",
            "placeholders": [
                "GITLAB_NAMESPACE",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "external-ci-and-code-quality-azure-pipelines-project",
            "category": "External CI and code quality",
            "title": "Azure Pipelines project",
            "description": "AZURE_PIPELINE is the numeric pipeline definition ID or a definition name accepted by Badgen. The click targets open the exact build definition rather than a generic Azure DevOps landing page.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 157,
            "template": "[![Continuous integration: Azure Pipelines.](https://flat.badgen.net/static/CI/Azure%20Pipelines/2560E0)](https://dev.azure.com/AZURE_ORG/AZURE_PROJECT/_build?definitionId=AZURE_PIPELINE) [![Azure Pipelines status.](https://flat.badgen.net/azure-pipelines/AZURE_ORG/AZURE_PROJECT/AZURE_PIPELINE)](https://dev.azure.com/AZURE_ORG/AZURE_PROJECT/_build?definitionId=AZURE_PIPELINE) [![Latest Azure Pipelines build version.](https://flat.badgen.net/azure-pipelines/build/version/AZURE_ORG/AZURE_PROJECT/AZURE_PIPELINE?color=0E7490)](https://dev.azure.com/AZURE_ORG/AZURE_PROJECT/_build?definitionId=AZURE_PIPELINE) [![Latest Azure Pipelines test results.](https://flat.badgen.net/azure-pipelines/build/test/AZURE_ORG/AZURE_PROJECT/AZURE_PIPELINE)](https://dev.azure.com/AZURE_ORG/AZURE_PROJECT/_build?definitionId=AZURE_PIPELINE)",
            "placeholders": [
                "AZURE_ORG",
                "AZURE_PROJECT",
                "AZURE_PIPELINE"
            ],
            "providerBadgeCounts": {
                "badgen": 4
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 4
        },
        {
            "id": "external-ci-and-code-quality-circleci-project",
            "category": "External CI and code quality",
            "title": "CircleCI project",
            "description": "This row pairs the external build result with a small set of GitHub maintenance signals. Remove the GitHub badges when the source is hosted elsewhere.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 167,
            "template": "[![CircleCI build on CI_BRANCH.](https://flat.badgen.net/circleci/github/CI_OWNER/CI_REPO/CI_BRANCH)](https://app.circleci.com/pipelines/github/CI_OWNER/CI_REPO) [![Last GitHub commit on CI_BRANCH.](https://flat.badgen.net/github/last-commit/CI_OWNER/CI_REPO/CI_BRANCH?color=475569)](https://github.com/CI_OWNER/CI_REPO/commits/CI_BRANCH) [![GitHub stars.](https://flat.badgen.net/github/stars/CI_OWNER/CI_REPO?color=B45309)](https://github.com/CI_OWNER/CI_REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/CI_OWNER/CI_REPO?color=B91C1C)](https://github.com/CI_OWNER/CI_REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/CI_OWNER/CI_REPO?color=4338CA)](https://github.com/CI_OWNER/CI_REPO/blob/CI_BRANCH/LICENSE)",
            "placeholders": [
                "CI_BRANCH",
                "CI_OWNER",
                "CI_REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "external-ci-and-code-quality-travis-ci-project-with-coveralls",
            "category": "External CI and code quality",
            "title": "Travis CI project with Coveralls",
            "description": "Use this only for a public GitHub repository that still runs on Travis CI and publishes coverage to Coveralls. The branch is explicit in both status badges so the row does not silently mix results from different refs.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 177,
            "template": "[![Travis CI build on CI_BRANCH.](https://flat.badgen.net/travis/CI_OWNER/CI_REPO/CI_BRANCH)](https://app.travis-ci.com/github/CI_OWNER/CI_REPO) [![Coveralls coverage on CI_BRANCH.](https://flat.badgen.net/coveralls/c/github/CI_OWNER/CI_REPO/CI_BRANCH)](https://coveralls.io/github/CI_OWNER/CI_REPO?branch=CI_BRANCH) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/CI_OWNER/CI_REPO/stable?color=0E7490)](https://github.com/CI_OWNER/CI_REPO/releases/latest) [![Last GitHub commit on CI_BRANCH.](https://flat.badgen.net/github/last-commit/CI_OWNER/CI_REPO/CI_BRANCH?color=475569)](https://github.com/CI_OWNER/CI_REPO/commits/CI_BRANCH) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/CI_OWNER/CI_REPO?color=B91C1C)](https://github.com/CI_OWNER/CI_REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/CI_OWNER/CI_REPO?color=4338CA)](https://github.com/CI_OWNER/CI_REPO/blob/CI_BRANCH/LICENSE)",
            "placeholders": [
                "CI_BRANCH",
                "CI_OWNER",
                "CI_REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "external-ci-and-code-quality-appveyor-windows-project",
            "category": "External CI and code quality",
            "title": "AppVeyor Windows project",
            "description": "Keep this row for projects whose Windows build is actually public in AppVeyor. APPVEYOR_ACCOUNT may be a user or organization slug.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 187,
            "template": "[![AppVeyor Windows build.](https://flat.badgen.net/appveyor/ci/APPVEYOR_ACCOUNT/APPVEYOR_PROJECT)](https://ci.appveyor.com/project/APPVEYOR_ACCOUNT/APPVEYOR_PROJECT) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Latest release asset downloads.](https://flat.badgen.net/github/assets-dl/OWNER/REPO?color=C2410C)](https://github.com/OWNER/REPO/releases/latest) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "APPVEYOR_ACCOUNT",
                "APPVEYOR_PROJECT",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "external-ci-and-code-quality-code-climate-quality-report",
            "category": "External CI and code quality",
            "title": "Code Climate quality report",
            "description": "Code Climate analysis must be public for these badges to resolve. Coverage can legitimately differ from another provider, so keep only the report your project treats as authoritative.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 197,
            "template": "[![Code Climate maintainability.](https://flat.badgen.net/codeclimate/maintainability/CODECLIMATE_ORG/CODECLIMATE_REPO)](https://codeclimate.com/github/CODECLIMATE_ORG/CODECLIMATE_REPO) [![Code Climate technical debt.](https://flat.badgen.net/codeclimate/tech-debt/CODECLIMATE_ORG/CODECLIMATE_REPO?color=C2410C)](https://codeclimate.com/github/CODECLIMATE_ORG/CODECLIMATE_REPO) [![Code Climate issues.](https://flat.badgen.net/codeclimate/issues/CODECLIMATE_ORG/CODECLIMATE_REPO?color=B91C1C)](https://codeclimate.com/github/CODECLIMATE_ORG/CODECLIMATE_REPO/issues) [![Code Climate coverage.](https://flat.badgen.net/codeclimate/coverage/CODECLIMATE_ORG/CODECLIMATE_REPO)](https://codeclimate.com/github/CODECLIMATE_ORG/CODECLIMATE_REPO/test_coverage) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "CODECLIMATE_ORG",
                "CODECLIMATE_REPO",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "javascript-and-typescript-general-npm-package",
            "category": "JavaScript and TypeScript",
            "title": "General npm package",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 209,
            "template": "[![Latest npm version.](https://flat.badgen.net/npm/v/PACKAGE?color=0E7490)](https://www.npmjs.com/package/PACKAGE) [![Monthly npm downloads.](https://flat.badgen.net/npm/dm/PACKAGE?color=BE185D)](https://www.npmjs.com/package/PACKAGE) [![Supported Node.js versions.](https://flat.badgen.net/npm/node/PACKAGE?color=4D7C0F)](https://www.npmjs.com/package/PACKAGE) [![TypeScript declaration status.](https://flat.badgen.net/npm/types/PACKAGE?color=6D28D9)](https://www.npmjs.com/package/PACKAGE) [![Package dependents.](https://flat.badgen.net/github/dependents-pkg/OWNER/REPO?color=0F766E)](https://github.com/OWNER/REPO/network/dependents) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![NPM license.](https://flat.badgen.net/npm/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "javascript-and-typescript-typescript-library-with-coverage",
            "category": "JavaScript and TypeScript",
            "title": "TypeScript library with coverage",
            "description": "",
            "languages": [
                "TypeScript"
            ],
            "sourceLine": 217,
            "template": "[![Latest npm version.](https://flat.badgen.net/npm/v/PACKAGE?color=0E7490)](https://www.npmjs.com/package/PACKAGE) [![Monthly npm downloads.](https://flat.badgen.net/npm/dm/PACKAGE?color=BE185D)](https://www.npmjs.com/package/PACKAGE) [![Supported Node.js versions.](https://flat.badgen.net/npm/node/PACKAGE?color=4D7C0F)](https://www.npmjs.com/package/PACKAGE) [![Bundled TypeScript declarations.](https://flat.badgen.net/npm/types/PACKAGE?color=6D28D9)](https://www.npmjs.com/package/PACKAGE) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![NPM license.](https://flat.badgen.net/npm/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 8
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 8
        },
        {
            "id": "javascript-and-typescript-browser-first-npm-library-or-cdn-package",
            "category": "JavaScript and TypeScript",
            "title": "Browser-first npm library or CDN package",
            "description": "BundleJS and Packagephobia depend on successfully analyzing the package. Preview both badges before committing them.",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 225,
            "template": "[![Latest npm version.](https://flat.badgen.net/npm/v/PACKAGE?color=0E7490)](https://www.npmjs.com/package/PACKAGE) [![Monthly jsDelivr hits.](https://flat.badgen.net/jsdelivr/hits/npm/PACKAGE?color=BE185D)](https://www.jsdelivr.com/package/npm/PACKAGE) [![Minified and gzipped bundle size.](https://flat.badgen.net/bundlejs/minzip/PACKAGE?color=C2410C)](https://bundlejs.com/?q=PACKAGE) [![Published package size.](https://flat.badgen.net/packagephobia/publish/PACKAGE?color=475569)](https://packagephobia.com/result?p=PACKAGE) [![Bundled TypeScript declarations.](https://flat.badgen.net/npm/types/PACKAGE?color=6D28D9)](https://www.npmjs.com/package/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![NPM license.](https://flat.badgen.net/npm/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "javascript-and-typescript-bundle-conscious-npm-library",
            "category": "JavaScript and TypeScript",
            "title": "Bundle-conscious npm library",
            "description": "Bundlephobia can report compressed size, dependency count, and tree-shaking support from the same published package. These are analyzer results rather than package guarantees, so preview the row after every packaging change.",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 235,
            "template": "[![Latest npm version.](https://flat.badgen.net/npm/v/PACKAGE?color=0E7490)](https://www.npmjs.com/package/PACKAGE) [![Minified and gzipped Bundlephobia size.](https://flat.badgen.net/bundlephobia/minzip/PACKAGE?color=C2410C)](https://bundlephobia.com/package/PACKAGE) [![Runtime dependency count.](https://flat.badgen.net/bundlephobia/dependency-count/PACKAGE?color=475569)](https://bundlephobia.com/package/PACKAGE) [![Tree-shaking support.](https://flat.badgen.net/bundlephobia/tree-shaking/PACKAGE?color=4D7C0F)](https://bundlephobia.com/package/PACKAGE) [![Monthly jsDelivr hits.](https://flat.badgen.net/jsdelivr/hits/npm/PACKAGE?color=BE185D)](https://www.jsdelivr.com/package/npm/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![NPM license.](https://flat.badgen.net/npm/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "javascript-and-typescript-npm-cli",
            "category": "JavaScript and TypeScript",
            "title": "npm CLI",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 245,
            "template": "[![Latest npm CLI version.](https://flat.badgen.net/npm/v/PACKAGE?color=0E7490)](https://www.npmjs.com/package/PACKAGE) [![Monthly npm downloads.](https://flat.badgen.net/npm/dm/PACKAGE?color=BE185D)](https://www.npmjs.com/package/PACKAGE) [![Supported Node.js versions.](https://flat.badgen.net/npm/node/PACKAGE?color=4D7C0F)](https://www.npmjs.com/package/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=7E22CE)](https://github.com/OWNER/REPO/releases/latest) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![NPM license.](https://flat.badgen.net/npm/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "javascript-and-typescript-eslint-prettier-stylelint-remark-or-typedoc-plugin",
            "category": "JavaScript and TypeScript",
            "title": "ESLint, Prettier, Stylelint, remark, or TypeDoc plugin",
            "description": "Use the same strong signal order for tooling plugins. If the package is JavaScript-only, remove the TypeScript declarations badge. TOOL_NAME is display text such as ESLint plugin or TypeDoc plugin.",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 253,
            "template": "[![Project type: TOOL_NAME.](https://flat.badgen.net/static/type/TOOL_NAME/A21CAF)](https://github.com/OWNER/REPO) [![Latest npm version.](https://flat.badgen.net/npm/v/PACKAGE?color=0E7490)](https://www.npmjs.com/package/PACKAGE) [![Monthly npm downloads.](https://flat.badgen.net/npm/dm/PACKAGE?color=BE185D)](https://www.npmjs.com/package/PACKAGE) [![Supported Node.js versions.](https://flat.badgen.net/npm/node/PACKAGE?color=4D7C0F)](https://www.npmjs.com/package/PACKAGE) [![TypeScript declaration status.](https://flat.badgen.net/npm/types/PACKAGE?color=6D28D9)](https://www.npmjs.com/package/PACKAGE) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![NPM license.](https://flat.badgen.net/npm/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "TOOL_NAME",
                "OWNER",
                "REPO",
                "PACKAGE",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 8
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 8
        },
        {
            "id": "language-first-repositories-c-or-c-library-and-native-application",
            "category": "Language-first repositories",
            "title": "C or C++ library and native application",
            "description": "",
            "languages": [
                "C",
                "C++"
            ],
            "sourceLine": 267,
            "template": "[![Primary language: C or C++.](https://flat.badgen.net/static/language/C%20or%20C%2B%2B/00599C)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Native build checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-java-kotlin-groovy-scala-or-clojure-project",
            "category": "Language-first repositories",
            "title": "Java, Kotlin, Groovy, Scala, or Clojure project",
            "description": "",
            "languages": [
                "Java",
                "Kotlin",
                "Groovy",
                "Scala",
                "Clojure"
            ],
            "sourceLine": 275,
            "template": "[![Platform: JVM.](https://flat.badgen.net/static/platform/JVM/EA2D2E)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![JVM build checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-c-f-or-visual-basic-net-project",
            "category": "Language-first repositories",
            "title": "C#, F#, or Visual Basic .NET project",
            "description": "",
            "languages": [
                "C#",
                "F#",
                "Visual Basic .NET"
            ],
            "sourceLine": 283,
            "template": "[![Platform: .NET.](https://flat.badgen.net/static/platform/.NET/512BD4)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![.NET build checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-python-application-service-or-tool",
            "category": "Language-first repositories",
            "title": "Python application, service, or tool",
            "description": "",
            "languages": [
                "Python"
            ],
            "sourceLine": 291,
            "template": "[![Primary language: Python.](https://flat.badgen.net/static/language/Python/3776AB)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Python checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-go-command-service-or-library",
            "category": "Language-first repositories",
            "title": "Go command, service, or library",
            "description": "",
            "languages": [
                "Go"
            ],
            "sourceLine": 299,
            "template": "[![Primary language: Go.](https://flat.badgen.net/static/language/Go/00ADD8)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Go checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-rust-application-or-command-line-tool",
            "category": "Language-first repositories",
            "title": "Rust application or command-line tool",
            "description": "",
            "languages": [
                "Rust"
            ],
            "sourceLine": 307,
            "template": "[![Primary language: Rust.](https://flat.badgen.net/static/language/Rust/CE412B)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Rust checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-ruby-or-php-application",
            "category": "Language-first repositories",
            "title": "Ruby or PHP application",
            "description": "",
            "languages": [
                "Ruby",
                "PHP"
            ],
            "sourceLine": 315,
            "template": "[![Primary language: Ruby or PHP.](https://flat.badgen.net/static/language/Ruby%20or%20PHP/CC342D)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Application checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-swift-objective-c-dart-or-flutter-application",
            "category": "Language-first repositories",
            "title": "Swift, Objective-C, Dart, or Flutter application",
            "description": "",
            "languages": [
                "Swift",
                "Objective-C",
                "Dart"
            ],
            "sourceLine": 323,
            "template": "[![Platform: Apple or Flutter.](https://flat.badgen.net/static/platform/Apple%20or%20Flutter/F05138)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Application checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-bash-zsh-fish-or-posix-shell-project",
            "category": "Language-first repositories",
            "title": "Bash, Zsh, Fish, or POSIX shell project",
            "description": "",
            "languages": [
                "Bash",
                "Zsh",
                "Fish",
                "Shell"
            ],
            "sourceLine": 331,
            "template": "[![Primary language: Shell.](https://flat.badgen.net/static/language/Shell/4EAA25)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Shell checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-powershell-automation-repository",
            "category": "Language-first repositories",
            "title": "PowerShell automation repository",
            "description": "",
            "languages": [
                "PowerShell"
            ],
            "sourceLine": 339,
            "template": "[![Primary language: PowerShell.](https://flat.badgen.net/static/language/PowerShell/5391FE)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![PowerShell checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-lua-elixir-or-erlang-project",
            "category": "Language-first repositories",
            "title": "Lua, Elixir, or Erlang project",
            "description": "",
            "languages": [
                "Lua",
                "Elixir",
                "Erlang"
            ],
            "sourceLine": 347,
            "template": "[![Runtime: Lua or BEAM.](https://flat.badgen.net/static/runtime/Lua%20or%20BEAM/5849BE)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Runtime checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-julia-scientific-computing-project",
            "category": "Language-first repositories",
            "title": "Julia scientific-computing project",
            "description": "",
            "languages": [
                "Julia"
            ],
            "sourceLine": 355,
            "template": "[![Primary language: Julia.](https://flat.badgen.net/static/language/Julia/9558B2)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Julia checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-first-repositories-zig-nim-or-emerging-systems-language-project",
            "category": "Language-first repositories",
            "title": "Zig, Nim, or emerging systems-language project",
            "description": "",
            "languages": [
                "Zig",
                "Nim"
            ],
            "sourceLine": 363,
            "template": "[![Language family: Zig or Nim.](https://flat.badgen.net/static/language/Zig%20or%20Nim/F7A41D)](https://github.com/OWNER/REPO) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Systems build checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "containers-infrastructure-and-unsupported-registries-docker-image",
            "category": "Containers, infrastructure, and unsupported registries",
            "title": "Docker image",
            "description": "",
            "languages": [
                "Dockerfile"
            ],
            "sourceLine": 373,
            "template": "[![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Docker Hub pulls.](https://flat.badgen.net/docker/pulls/DOCKER_SCOPE/IMAGE?color=BE185D)](https://hub.docker.com/r/DOCKER_SCOPE/IMAGE) [![Docker Hub stars.](https://flat.badgen.net/docker/stars/DOCKER_SCOPE/IMAGE?color=B45309)](https://hub.docker.com/r/DOCKER_SCOPE/IMAGE) [![Docker image size for TAG on ARCH.](https://flat.badgen.net/docker/size/DOCKER_SCOPE/IMAGE/TAG/ARCH?color=C2410C)](https://hub.docker.com/r/DOCKER_SCOPE/IMAGE/tags) [![Docker image layers for TAG on ARCH.](https://flat.badgen.net/docker/layers/DOCKER_SCOPE/IMAGE/TAG/ARCH?color=7E22CE)](https://hub.docker.com/r/DOCKER_SCOPE/IMAGE/tags) [![Container checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "DOCKER_SCOPE",
                "IMAGE",
                "TAG",
                "ARCH",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "containers-infrastructure-and-unsupported-registries-go-module",
            "category": "Containers, infrastructure, and unsupported registries",
            "title": "Go module",
            "description": "Badgen has no first-party Go module proxy generator, so use dynamic GitHub signals and one honest static identity badge.",
            "languages": [
                "Go"
            ],
            "sourceLine": 381,
            "template": "[![Language: Go.](https://flat.badgen.net/static/language/Go/1D4ED8)](https://go.dev) [![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "containers-infrastructure-and-unsupported-registries-powershell-module",
            "category": "Containers, infrastructure, and unsupported registries",
            "title": "PowerShell module",
            "description": "Badgen has no PowerShell Gallery generator, so do not fake a dynamic PSGallery version. Use the GitHub release as the live version signal.",
            "languages": [
                "PowerShell"
            ],
            "sourceLine": 391,
            "template": "[![Runtime: PowerShell.](https://flat.badgen.net/static/runtime/PowerShell/1D4ED8)](https://www.powershellgallery.com/packages/MODULE) [![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "MODULE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "containers-infrastructure-and-unsupported-registries-terraform-provider-or-module",
            "category": "Containers, infrastructure, and unsupported registries",
            "title": "Terraform provider or module",
            "description": "",
            "languages": [
                "HCL"
            ],
            "sourceLine": 401,
            "template": "[![Ecosystem: Terraform.](https://flat.badgen.net/static/ecosystem/Terraform/6D28D9)](https://registry.terraform.io/providers/OWNER/PACKAGE/latest) [![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "PACKAGE",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "containers-infrastructure-and-unsupported-registries-helm-chart-or-kubernetes-add-on",
            "category": "Containers, infrastructure, and unsupported registries",
            "title": "Helm chart or Kubernetes add-on",
            "description": "",
            "languages": [
                "YAML"
            ],
            "sourceLine": 409,
            "template": "[![Package type: Helm chart.](https://flat.badgen.net/static/package/Helm%20chart/0369A1)](https://artifacthub.io/packages/search?ts_query_web=PACKAGE) [![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-package-registries-python-package-on-pypi",
            "category": "Language package registries",
            "title": "Python package on PyPI",
            "description": "PyPI download-count badges currently receive an upstream 429 through Badgen, so this row omits that misleading error badge.",
            "languages": [
                "Python"
            ],
            "sourceLine": 419,
            "template": "[![Latest PyPI version.](https://flat.badgen.net/pypi/v/PACKAGE?color=0E7490)](https://pypi.org/project/PACKAGE/) [![Supported Python versions.](https://flat.badgen.net/pypi/python/PACKAGE?color=4D7C0F)](https://pypi.org/project/PACKAGE/) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=7E22CE)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 8
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 8
        },
        {
            "id": "language-package-registries-rust-crate",
            "category": "Language package registries",
            "title": "Rust crate",
            "description": "",
            "languages": [
                "Rust"
            ],
            "sourceLine": 429,
            "template": "[![Latest crates.io version.](https://flat.badgen.net/crates/v/CRATE?color=0E7490)](https://crates.io/crates/CRATE) [![Total crates.io downloads.](https://flat.badgen.net/crates/d/CRATE?color=BE185D)](https://crates.io/crates/CRATE) [![Downloads of the latest crate version.](https://flat.badgen.net/crates/dl/CRATE?color=C2410C)](https://crates.io/crates/CRATE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "CRATE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "language-package-registries-ruby-gem",
            "category": "Language package registries",
            "title": "Ruby gem",
            "description": "",
            "languages": [
                "Ruby"
            ],
            "sourceLine": 437,
            "template": "[![Latest stable RubyGems version.](https://flat.badgen.net/rubygems/v/GEM?color=0E7490)](https://rubygems.org/gems/GEM) [![Total RubyGems downloads.](https://flat.badgen.net/rubygems/dt/GEM?color=BE185D)](https://rubygems.org/gems/GEM) [![Downloads of the latest gem version.](https://flat.badgen.net/rubygems/dv/GEM?color=C2410C)](https://rubygems.org/gems/GEM) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "GEM",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "language-package-registries-php-package-on-packagist",
            "category": "Language package registries",
            "title": "PHP package on Packagist",
            "description": "",
            "languages": [
                "PHP"
            ],
            "sourceLine": 445,
            "template": "[![Latest Packagist version.](https://flat.badgen.net/packagist/v/VENDOR/PACKAGE?color=0E7490)](https://packagist.org/packages/VENDOR/PACKAGE) [![Total Packagist downloads.](https://flat.badgen.net/packagist/dt/VENDOR/PACKAGE?color=BE185D)](https://packagist.org/packages/VENDOR/PACKAGE) [![Supported PHP version.](https://flat.badgen.net/packagist/php/VENDOR/PACKAGE?color=4D7C0F)](https://packagist.org/packages/VENDOR/PACKAGE) [![Packagist dependents.](https://flat.badgen.net/packagist/dependents/VENDOR/PACKAGE?color=0F766E)](https://packagist.org/packages/VENDOR/PACKAGE/dependents) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![Packagist license.](https://flat.badgen.net/packagist/license/VENDOR/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "VENDOR",
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "language-package-registries-net-package-on-nuget",
            "category": "Language package registries",
            "title": ".NET package on NuGet",
            "description": "",
            "languages": [
                "C#",
                "F#",
                "Visual Basic .NET"
            ],
            "sourceLine": 453,
            "template": "[![Latest stable NuGet version.](https://flat.badgen.net/nuget/v/PACKAGE?color=0E7490)](https://www.nuget.org/packages/PACKAGE) [![Total NuGet downloads.](https://flat.badgen.net/nuget/dt/PACKAGE?color=BE185D)](https://www.nuget.org/packages/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "language-package-registries-jvm-library-on-maven-central",
            "category": "Language package registries",
            "title": "JVM library on Maven Central",
            "description": "",
            "languages": [
                "Java",
                "Kotlin",
                "Groovy",
                "Scala",
                "Clojure"
            ],
            "sourceLine": 461,
            "template": "[![Latest Maven Central version.](https://flat.badgen.net/maven/v/maven-central/GROUP_ID/ARTIFACT_ID?color=0E7490)](https://central.sonatype.com/artifact/GROUP_ID/ARTIFACT_ID) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=7E22CE)](https://github.com/OWNER/REPO/releases/latest) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "GROUP_ID",
                "ARTIFACT_ID",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "language-package-registries-dart-or-flutter-package",
            "category": "Language package registries",
            "title": "Dart or Flutter package",
            "description": "Use either the Dart-platform or Flutter-platform badge, not both, unless the package genuinely spans both metadata models.",
            "languages": [
                "Dart"
            ],
            "sourceLine": 469,
            "template": "[![Latest pub.dev version.](https://flat.badgen.net/pub/v/PACKAGE?color=0E7490)](https://pub.dev/packages/PACKAGE) [![Monthly pub.dev downloads.](https://flat.badgen.net/pub/dm/PACKAGE?color=BE185D)](https://pub.dev/packages/PACKAGE) [![Supported Dart SDK.](https://flat.badgen.net/pub/sdk-version/PACKAGE?color=4D7C0F)](https://pub.dev/packages/PACKAGE) [![Pub points.](https://flat.badgen.net/pub/points/PACKAGE?color=6D28D9)](https://pub.dev/packages/PACKAGE/score) [![Pub likes.](https://flat.badgen.net/pub/likes/PACKAGE?color=B45309)](https://pub.dev/packages/PACKAGE/score) [![Supported Flutter platforms.](https://flat.badgen.net/pub/flutter-platform/PACKAGE?color=C2410C)](https://pub.dev/packages/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Pub license.](https://flat.badgen.net/pub/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 8
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 8
        },
        {
            "id": "language-package-registries-haskell-package-on-hackage",
            "category": "Language package registries",
            "title": "Haskell package on Hackage",
            "description": "",
            "languages": [
                "Haskell"
            ],
            "sourceLine": 479,
            "template": "[![Latest Hackage version.](https://flat.badgen.net/hackage/v/PACKAGE?color=0E7490)](https://hackage.haskell.org/package/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![Hackage license.](https://flat.badgen.net/hackage/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-r-package-on-cran",
            "category": "Language package registries",
            "title": "R package on CRAN",
            "description": "",
            "languages": [
                "R"
            ],
            "sourceLine": 487,
            "template": "[![Latest CRAN version.](https://flat.badgen.net/cran/v/PACKAGE?color=0E7490)](https://cran.r-project.org/package=PACKAGE) [![Total CRAN downloads.](https://flat.badgen.net/cran/dt/PACKAGE?color=BE185D)](https://cran.r-project.org/package=PACKAGE) [![Required R version.](https://flat.badgen.net/cran/r/PACKAGE?color=4D7C0F)](https://cran.r-project.org/package=PACKAGE) [![CRAN dependents.](https://flat.badgen.net/cran/dependents/PACKAGE?color=0F766E)](https://cran.r-project.org/package=PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![CRAN license.](https://flat.badgen.net/cran/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "language-package-registries-latex-package-on-ctan",
            "category": "Language package registries",
            "title": "LaTeX package on CTAN",
            "description": "",
            "languages": [
                "TeX"
            ],
            "sourceLine": 495,
            "template": "[![Latest CTAN version.](https://flat.badgen.net/ctan/v/PACKAGE?color=0E7490)](https://ctan.org/pkg/PACKAGE) [![CTAN rating.](https://flat.badgen.net/ctan/rating/PACKAGE?color=B45309)](https://ctan.org/pkg/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![CTAN license.](https://flat.badgen.net/ctan/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-d-package-on-dub",
            "category": "Language package registries",
            "title": "D package on DUB",
            "description": "",
            "languages": [
                "D"
            ],
            "sourceLine": 503,
            "template": "[![Latest DUB version.](https://flat.badgen.net/dub/v/PACKAGE?color=0E7490)](https://code.dlang.org/packages/PACKAGE) [![Total DUB downloads.](https://flat.badgen.net/dub/dt/PACKAGE?color=BE185D)](https://code.dlang.org/packages/PACKAGE) [![DUB rating.](https://flat.badgen.net/dub/rating/PACKAGE?color=B45309)](https://code.dlang.org/packages/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![DUB license.](https://flat.badgen.net/dub/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-elm-package",
            "category": "Language package registries",
            "title": "Elm package",
            "description": "",
            "languages": [
                "Elm"
            ],
            "sourceLine": 511,
            "template": "[![Latest Elm package version.](https://flat.badgen.net/elm-package/v/OWNER/PACKAGE?color=0E7490)](https://package.elm-lang.org/packages/OWNER/PACKAGE/latest/) [![Supported Elm version.](https://flat.badgen.net/elm-package/elm/OWNER/PACKAGE?color=4D7C0F)](https://package.elm-lang.org/packages/OWNER/PACKAGE/latest/) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![Elm package license.](https://flat.badgen.net/elm-package/license/OWNER/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "PACKAGE",
                "BRANCH",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-haxe-package-on-haxelib",
            "category": "Language package registries",
            "title": "Haxe package on haxelib",
            "description": "",
            "languages": [
                "Haxe"
            ],
            "sourceLine": 519,
            "template": "[![Latest haxelib version.](https://flat.badgen.net/haxelib/v/PACKAGE?color=0E7490)](https://lib.haxe.org/p/PACKAGE/) [![Total haxelib downloads.](https://flat.badgen.net/haxelib/d/PACKAGE?color=BE185D)](https://lib.haxe.org/p/PACKAGE/) [![Downloads of the latest haxelib version.](https://flat.badgen.net/haxelib/dl/PACKAGE?color=C2410C)](https://lib.haxe.org/p/PACKAGE/) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![haxelib license.](https://flat.badgen.net/haxelib/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-ocaml-package-on-opam",
            "category": "Language package registries",
            "title": "OCaml package on opam",
            "description": "",
            "languages": [
                "OCaml"
            ],
            "sourceLine": 527,
            "template": "[![Latest opam version.](https://flat.badgen.net/opam/v/PACKAGE?color=0E7490)](https://opam.ocaml.org/packages/PACKAGE/) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![opam license.](https://flat.badgen.net/opam/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-perl-distribution-on-cpan",
            "category": "Language package registries",
            "title": "Perl distribution on CPAN",
            "description": "Use the CPAN distribution name in DISTRIBUTION; Badgen also accepts module-style identifiers where the registry does.",
            "languages": [
                "Perl"
            ],
            "sourceLine": 535,
            "template": "[![Latest CPAN version.](https://flat.badgen.net/cpan/v/DISTRIBUTION?color=0E7490)](https://metacpan.org/dist/DISTRIBUTION) [![Required Perl version.](https://flat.badgen.net/cpan/perl/DISTRIBUTION?color=4D7C0F)](https://metacpan.org/dist/DISTRIBUTION) [![CPAN dependents.](https://flat.badgen.net/cpan/dependents/DISTRIBUTION?color=0F766E)](https://metacpan.org/dist/DISTRIBUTION) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![CPAN license.](https://flat.badgen.net/cpan/license/DISTRIBUTION?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "DISTRIBUTION",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-crystal-shard",
            "category": "Language package registries",
            "title": "Crystal shard",
            "description": "",
            "languages": [
                "Crystal"
            ],
            "sourceLine": 545,
            "template": "[![Latest shard version.](https://flat.badgen.net/shards/v/PACKAGE?color=0E7490)](https://github.com/OWNER/REPO/releases) [![Required Crystal version.](https://flat.badgen.net/shards/crystal/PACKAGE?color=4D7C0F)](https://github.com/OWNER/REPO) [![Shard dependents.](https://flat.badgen.net/shards/dependents/PACKAGE?color=0F766E)](https://github.com/OWNER/REPO/network/dependents) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Shard license.](https://flat.badgen.net/shards/license/PACKAGE?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "language-package-registries-swift-or-objective-c-library-on-cocoapods",
            "category": "Language package registries",
            "title": "Swift or Objective-C library on CocoaPods",
            "description": "",
            "languages": [
                "Swift",
                "Objective-C"
            ],
            "sourceLine": 553,
            "template": "[![Latest CocoaPods version.](https://flat.badgen.net/cocoapods/v/POD?color=0E7490)](https://cocoapods.org/pods/POD) [![Supported Apple platforms.](https://flat.badgen.net/cocoapods/p/POD?color=6D28D9)](https://cocoapods.org/pods/POD) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![Codecov coverage.](https://flat.badgen.net/codecov/github/OWNER/REPO/BRANCH)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "POD",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "language-package-registries-emacs-package-on-melpa",
            "category": "Language package registries",
            "title": "Emacs package on MELPA",
            "description": "MELPA exposes a live version badge but not adoption or licensing metadata through Badgen, so the rest of the row uses repository signals.",
            "languages": [
                "Emacs Lisp"
            ],
            "sourceLine": 561,
            "template": "[![Latest MELPA version.](https://flat.badgen.net/melpa/v/PACKAGE?color=0E7490)](https://melpa.org/#/PACKAGE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "editor-and-browser-extensions-visual-studio-marketplace-extension",
            "category": "Editor and browser extensions",
            "title": "Visual Studio Marketplace extension",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 573,
            "template": "[![Latest Visual Studio Marketplace version.](https://flat.badgen.net/vs-marketplace/v/PUBLISHER.EXTENSION?color=0E7490)](https://marketplace.visualstudio.com/items?itemName=PUBLISHER.EXTENSION) [![Visual Studio Marketplace installs.](https://flat.badgen.net/vs-marketplace/i/PUBLISHER.EXTENSION?color=BE185D)](https://marketplace.visualstudio.com/items?itemName=PUBLISHER.EXTENSION) [![Visual Studio Marketplace downloads.](https://flat.badgen.net/vs-marketplace/d/PUBLISHER.EXTENSION?color=C2410C)](https://marketplace.visualstudio.com/items?itemName=PUBLISHER.EXTENSION) [![Visual Studio Marketplace rating.](https://flat.badgen.net/vs-marketplace/rating/PUBLISHER.EXTENSION?color=B45309)](https://marketplace.visualstudio.com/items?itemName=PUBLISHER.EXTENSION&ssr=false#review-details) [![Extension checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PUBLISHER.EXTENSION",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "editor-and-browser-extensions-dual-published-vs-code-and-open-vsx-extension",
            "category": "Editor and browser extensions",
            "title": "Dual-published VS Code and Open VSX extension",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 581,
            "template": "[![Latest Visual Studio Marketplace version.](https://flat.badgen.net/vs-marketplace/v/PUBLISHER.EXTENSION?color=0E7490)](https://marketplace.visualstudio.com/items?itemName=PUBLISHER.EXTENSION) [![Visual Studio Marketplace installs.](https://flat.badgen.net/vs-marketplace/i/PUBLISHER.EXTENSION?color=BE185D)](https://marketplace.visualstudio.com/items?itemName=PUBLISHER.EXTENSION) [![Latest Open VSX version.](https://flat.badgen.net/open-vsx/version/NAMESPACE/EXTENSION?color=7E22CE)](https://open-vsx.org/extension/NAMESPACE/EXTENSION) [![Open VSX downloads.](https://flat.badgen.net/open-vsx/d/NAMESPACE/EXTENSION?color=C2410C)](https://open-vsx.org/extension/NAMESPACE/EXTENSION) [![Extension checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PUBLISHER.EXTENSION",
                "NAMESPACE",
                "EXTENSION",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "editor-and-browser-extensions-chrome-extension",
            "category": "Editor and browser extensions",
            "title": "Chrome extension",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 589,
            "template": "[![Latest Chrome Web Store version.](https://flat.badgen.net/chrome-web-store/v/EXTENSION_ID?color=0E7490)](https://chromewebstore.google.com/detail/EXTENSION_ID) [![Chrome Web Store users.](https://flat.badgen.net/chrome-web-store/users/EXTENSION_ID?color=BE185D)](https://chromewebstore.google.com/detail/EXTENSION_ID) [![Chrome Web Store rating.](https://flat.badgen.net/chrome-web-store/rating/EXTENSION_ID?color=B45309)](https://chromewebstore.google.com/detail/EXTENSION_ID/reviews) [![Chrome Web Store rating count.](https://flat.badgen.net/chrome-web-store/rating-count/EXTENSION_ID?color=7E22CE)](https://chromewebstore.google.com/detail/EXTENSION_ID/reviews) [![Extension checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "EXTENSION_ID",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "editor-and-browser-extensions-firefox-add-on",
            "category": "Editor and browser extensions",
            "title": "Firefox add-on",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 597,
            "template": "[![Latest Firefox Add-ons version.](https://flat.badgen.net/amo/v/ADDON_SLUG?color=0E7490)](https://addons.mozilla.org/firefox/addon/ADDON_SLUG/) [![Firefox Add-ons users.](https://flat.badgen.net/amo/users/ADDON_SLUG?color=BE185D)](https://addons.mozilla.org/firefox/addon/ADDON_SLUG/) [![Firefox Add-ons rating.](https://flat.badgen.net/amo/rating/ADDON_SLUG?color=B45309)](https://addons.mozilla.org/firefox/addon/ADDON_SLUG/reviews/) [![Firefox Add-ons reviews.](https://flat.badgen.net/amo/reviews/ADDON_SLUG?color=7E22CE)](https://addons.mozilla.org/firefox/addon/ADDON_SLUG/reviews/) [![Extension checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "ADDON_SLUG",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "editor-and-browser-extensions-microsoft-edge-add-on",
            "category": "Editor and browser extensions",
            "title": "Microsoft Edge add-on",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 605,
            "template": "[![Latest Microsoft Edge Add-ons version.](https://flat.badgen.net/edge-addons/v/EXTENSION_ID?color=0E7490)](https://microsoftedge.microsoft.com/addons/detail/EXTENSION_ID) [![Microsoft Edge Add-ons users.](https://flat.badgen.net/edge-addons/users/EXTENSION_ID?color=BE185D)](https://microsoftedge.microsoft.com/addons/detail/EXTENSION_ID) [![Microsoft Edge Add-ons rating.](https://flat.badgen.net/edge-addons/rating/EXTENSION_ID?color=B45309)](https://microsoftedge.microsoft.com/addons/detail/EXTENSION_ID) [![Microsoft Edge Add-ons rating count.](https://flat.badgen.net/edge-addons/rating-count/EXTENSION_ID?color=7E22CE)](https://microsoftedge.microsoft.com/addons/detail/EXTENSION_ID) [![Extension checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "EXTENSION_ID",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "operating-system-distribution-windows-cli-distributed-through-winget-and-scoop",
            "category": "Operating-system distribution",
            "title": "Windows CLI distributed through winget and Scoop",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 615,
            "template": "[![Latest winget version.](https://flat.badgen.net/winget/v/WINGET_PACKAGE_ID?color=0E7490)](https://github.com/microsoft/winget-pkgs) [![Latest Scoop version.](https://flat.badgen.net/scoop/v/SCOOP_PACKAGE?color=7E22CE)](https://scoop.sh/#/apps?q=SCOOP_PACKAGE) [![Latest release asset downloads.](https://flat.badgen.net/github/assets-dl/OWNER/REPO?color=C2410C)](https://github.com/OWNER/REPO/releases/latest) [![Release checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "WINGET_PACKAGE_ID",
                "SCOOP_PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 7
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 7
        },
        {
            "id": "operating-system-distribution-homebrew-formula",
            "category": "Operating-system distribution",
            "title": "Homebrew formula",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 623,
            "template": "[![Latest Homebrew formula version.](https://flat.badgen.net/homebrew/v/FORMULA?color=0E7490)](https://formulae.brew.sh/formula/FORMULA) [![Monthly Homebrew downloads.](https://flat.badgen.net/homebrew/dm/FORMULA?color=BE185D)](https://formulae.brew.sh/formula/FORMULA) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=7E22CE)](https://github.com/OWNER/REPO/releases/latest) [![Release checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "FORMULA",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "operating-system-distribution-homebrew-cask",
            "category": "Operating-system distribution",
            "title": "Homebrew cask",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 631,
            "template": "[![Latest Homebrew cask version.](https://flat.badgen.net/homebrew/cask/v/CASK?color=0E7490)](https://formulae.brew.sh/cask/CASK) [![Monthly Homebrew cask downloads.](https://flat.badgen.net/homebrew/cask/dm/CASK?color=BE185D)](https://formulae.brew.sh/cask/CASK) [![Latest release asset downloads.](https://flat.badgen.net/github/assets-dl/OWNER/REPO?color=C2410C)](https://github.com/OWNER/REPO/releases/latest) [![Release checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "CASK",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "operating-system-distribution-snap-package",
            "category": "Operating-system distribution",
            "title": "Snap package",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 639,
            "template": "[![Latest Snap version.](https://flat.badgen.net/snapcraft/v/SNAP?color=0E7490)](https://snapcraft.io/SNAP) [![Snap distribution size.](https://flat.badgen.net/snapcraft/size/SNAP?color=C2410C)](https://snapcraft.io/SNAP) [![Supported Snap architectures.](https://flat.badgen.net/snapcraft/architecture/SNAP?color=6D28D9)](https://snapcraft.io/SNAP) [![Release checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![Snap license.](https://flat.badgen.net/snapcraft/license/SNAP?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "SNAP",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "operating-system-distribution-android-app-on-f-droid",
            "category": "Operating-system distribution",
            "title": "Android app on F-Droid",
            "description": "",
            "languages": [
                "Java",
                "Kotlin"
            ],
            "sourceLine": 647,
            "template": "[![Latest F-Droid version.](https://flat.badgen.net/f-droid/v/APP_ID?color=0E7490)](https://f-droid.org/packages/APP_ID/) [![Release checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![F-Droid license.](https://flat.badgen.net/f-droid/license/APP_ID?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "APP_ID",
                "BRANCH",
                "OWNER",
                "REPO"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "community-and-custom-metadata-open-collective-project",
            "category": "Community and custom metadata",
            "title": "Open Collective project",
            "description": "The Open Collective contributors endpoint currently produces undefined; use GitHub's contributors count instead.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 657,
            "template": "[![Open Collective backers.](https://flat.badgen.net/opencollective/backers/COLLECTIVE?color=BE185D)](https://opencollective.com/COLLECTIVE) [![Open Collective yearly income.](https://flat.badgen.net/opencollective/yearly/COLLECTIVE?color=0F766E)](https://opencollective.com/COLLECTIVE) [![Open Collective balance.](https://flat.badgen.net/opencollective/balance/COLLECTIVE?color=047857)](https://opencollective.com/COLLECTIVE) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=7E22CE)](https://github.com/OWNER/REPO/graphs/contributors) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "COLLECTIVE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "community-and-custom-metadata-project-with-a-discord-community",
            "category": "Community and custom metadata",
            "title": "Project with a Discord community",
            "description": "DISCORD_ID_OR_SLUG can be a supported public server identifier. Verify the preview before publishing.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 667,
            "template": "[![Latest stable release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![Discord community members.](https://flat.badgen.net/discord/members/DISCORD_ID_OR_SLUG?color=6D28D9)](https://discord.gg/INVITE_CODE) [![GitHub Actions checks on BRANCH.](https://flat.badgen.net/github/checks/OWNER/REPO/BRANCH)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "DISCORD_ID_OR_SLUG",
                "INVITE_CODE",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "community-and-custom-metadata-project-with-a-matrix-community",
            "category": "Community and custom metadata",
            "title": "Project with a Matrix community",
            "description": "Use the public room alias without the leading #. Matrix membership is the community signal; repository activity and licensing remain separate.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 677,
            "template": "[![Matrix room members.](https://flat.badgen.net/matrix/members/MATRIX_ROOM/MATRIX_SERVER?color=7E22CE)](https://matrix.to/#/#MATRIX_ROOM:MATRIX_SERVER) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=0F766E)](https://github.com/OWNER/REPO/graphs/contributors) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "MATRIX_ROOM",
                "MATRIX_SERVER",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "community-and-custom-metadata-project-with-a-mastodon-community",
            "category": "Community and custom metadata",
            "title": "Project with a Mastodon community",
            "description": "Keep the username and instance separate so the badge endpoint and profile destination both remain valid. This reports followers for a public profile; it is not a project-health signal.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 687,
            "template": "[![Mastodon followers.](https://flat.badgen.net/mastodon/follow/MASTODON_USER@MASTODON_SERVER?color=6D28D9)](https://MASTODON_SERVER/@MASTODON_USER) [![Latest stable GitHub release.](https://flat.badgen.net/github/release/OWNER/REPO/stable?color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub stars.](https://flat.badgen.net/github/stars/OWNER/REPO?color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=0F766E)](https://github.com/OWNER/REPO/graphs/contributors) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "MASTODON_USER",
                "MASTODON_SERVER",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "community-and-custom-metadata-liberapay-funded-open-source",
            "category": "Community and custom metadata",
            "title": "Liberapay-funded open source",
            "description": "Liberapay exposes receiving, patron-count, and goal-progress signals. Keep only metrics the project intentionally makes part of its funding story.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 697,
            "template": "[![Liberapay receiving.](https://flat.badgen.net/liberapay/receives/LIBERAPAY_ACCOUNT?color=047857)](https://liberapay.com/LIBERAPAY_ACCOUNT/) [![Liberapay patrons.](https://flat.badgen.net/liberapay/patrons/LIBERAPAY_ACCOUNT?color=BE185D)](https://liberapay.com/LIBERAPAY_ACCOUNT/) [![Liberapay goal progress.](https://flat.badgen.net/liberapay/goal/LIBERAPAY_ACCOUNT?color=0F766E)](https://liberapay.com/LIBERAPAY_ACCOUNT/) [![GitHub contributors.](https://flat.badgen.net/github/contributors/OWNER/REPO?color=7E22CE)](https://github.com/OWNER/REPO/graphs/contributors) [![GitHub open issues.](https://flat.badgen.net/github/open-issues/OWNER/REPO?color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "LIBERAPAY_ACCOUNT",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 6
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 6
        },
        {
            "id": "community-and-custom-metadata-honest-static-project-metadata",
            "category": "Community and custom metadata",
            "title": "Honest static project metadata",
            "description": "Static badges are appropriate for facts that change only when the repository changes. Do not use them to claim live build, coverage, security, or uptime status.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 707,
            "template": "[![API stability: stable.](https://flat.badgen.net/static/API/stable/047857)](https://github.com/OWNER/REPO/blob/BRANCH/docs/api.md) [![Module format: ESM.](https://flat.badgen.net/static/module/ESM/0E7490)](https://github.com/OWNER/REPO#usage) [![Platform: cross-platform.](https://flat.badgen.net/static/platform/cross-platform/6D28D9)](https://github.com/OWNER/REPO#compatibility) [![Code style: Prettier.](https://flat.badgen.net/static/code%20style/Prettier/A21CAF)](https://prettier.io) [![GitHub license.](https://flat.badgen.net/github/license/OWNER/REPO?color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 5
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 5
        },
        {
            "id": "alternative-and-provider-native-services-shields-io-github-repository",
            "category": "Alternative and provider-native services",
            "title": "Shields.io GitHub repository",
            "description": "Use WORKFLOW_FILE as a workflow filename such as quality.yml. Status colors remain dynamic.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 719,
            "template": "[![Latest GitHub release.](https://img.shields.io/github/v/release/OWNER/REPO?style=flat&color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions workflow status.](https://img.shields.io/github/actions/workflow/status/OWNER/REPO/WORKFLOW_FILE?branch=BRANCH&style=flat)](https://github.com/OWNER/REPO/actions/workflows/WORKFLOW_FILE) [![GitHub stars.](https://img.shields.io/github/stars/OWNER/REPO?style=flat&color=B45309)](https://github.com/OWNER/REPO/stargazers) [![GitHub forks.](https://img.shields.io/github/forks/OWNER/REPO?style=flat&color=C2410C)](https://github.com/OWNER/REPO/forks) [![GitHub open issues.](https://img.shields.io/github/issues/OWNER/REPO?style=flat&color=B91C1C)](https://github.com/OWNER/REPO/issues) [![GitHub contributors.](https://img.shields.io/github/contributors/OWNER/REPO?style=flat&color=7E22CE)](https://github.com/OWNER/REPO/graphs/contributors) [![GitHub license.](https://img.shields.io/github/license/OWNER/REPO?style=flat&color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "WORKFLOW_FILE",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "shields": 7
            },
            "providers": [
                "shields"
            ],
            "badgeCount": 7
        },
        {
            "id": "alternative-and-provider-native-services-shields-io-npm-package",
            "category": "Alternative and provider-native services",
            "title": "Shields.io npm package",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 729,
            "template": "[![Latest npm version.](https://img.shields.io/npm/v/PACKAGE?style=flat&color=0E7490)](https://www.npmjs.com/package/PACKAGE) [![Monthly npm downloads.](https://img.shields.io/npm/dm/PACKAGE?style=flat&color=BE185D)](https://www.npmjs.com/package/PACKAGE) [![Supported Node.js versions.](https://img.shields.io/node/v/PACKAGE?style=flat&color=4D7C0F)](https://www.npmjs.com/package/PACKAGE) [![Bundled TypeScript declarations.](https://img.shields.io/npm/types/PACKAGE?style=flat&color=6D28D9)](https://www.npmjs.com/package/PACKAGE) [![Minified and gzipped package size.](https://img.shields.io/bundlephobia/minzip/PACKAGE?style=flat&color=C2410C)](https://bundlephobia.com/package/PACKAGE) [![GitHub Actions workflow status.](https://img.shields.io/github/actions/workflow/status/OWNER/REPO/WORKFLOW_FILE?branch=BRANCH&style=flat)](https://github.com/OWNER/REPO/actions/workflows/WORKFLOW_FILE) [![NPM license.](https://img.shields.io/npm/l/PACKAGE?style=flat&color=4338CA)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "WORKFLOW_FILE",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "shields": 7
            },
            "providers": [
                "shields"
            ],
            "badgeCount": 7
        },
        {
            "id": "alternative-and-provider-native-services-shieldcn-github-repository",
            "category": "Alternative and provider-native services",
            "title": "shieldcn GitHub repository",
            "description": "",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 737,
            "template": "[![Latest GitHub release.](https://shieldcn.dev/github/OWNER/REPO/release.svg?size=xs)](https://github.com/OWNER/REPO/releases/latest) [![GitHub CI status.](https://shieldcn.dev/github/OWNER/REPO/ci.svg?size=xs)](https://github.com/OWNER/REPO/actions) [![GitHub stars.](https://shieldcn.dev/github/OWNER/REPO/stars.svg?size=xs)](https://github.com/OWNER/REPO/stargazers) [![GitHub forks.](https://shieldcn.dev/github/OWNER/REPO/forks.svg?size=xs)](https://github.com/OWNER/REPO/forks) [![GitHub open issues.](https://shieldcn.dev/github/OWNER/REPO/issues.svg?size=xs)](https://github.com/OWNER/REPO/issues) [![GitHub license.](https://shieldcn.dev/github/OWNER/REPO/license.svg?size=xs)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "shieldcn": 6
            },
            "providers": [
                "shieldcn"
            ],
            "badgeCount": 6
        },
        {
            "id": "alternative-and-provider-native-services-shieldcn-npm-package",
            "category": "Alternative and provider-native services",
            "title": "shieldcn npm package",
            "description": "",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 745,
            "template": "[![Latest npm version.](https://shieldcn.dev/npm/PACKAGE.svg?size=xs)](https://www.npmjs.com/package/PACKAGE) [![Weekly npm downloads.](https://shieldcn.dev/npm/PACKAGE/downloads.svg?size=xs)](https://www.npmjs.com/package/PACKAGE) [![Bundled TypeScript declarations.](https://shieldcn.dev/npm/types/PACKAGE.svg?size=xs)](https://www.npmjs.com/package/PACKAGE) [![NPM license.](https://shieldcn.dev/npm/license/PACKAGE.svg?size=xs)](https://github.com/OWNER/REPO/blob/BRANCH/LICENSE)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "shieldcn": 4
            },
            "providers": [
                "shieldcn"
            ],
            "badgeCount": 4
        },
        {
            "id": "alternative-and-provider-native-services-multi-provider-npm-package",
            "category": "Alternative and provider-native services",
            "title": "Multi-provider npm package",
            "description": "Keep only services configured for the project. FILE_PATH should identify the published build file whose gzip size matters.",
            "languages": [
                "JavaScript",
                "TypeScript"
            ],
            "sourceLine": 753,
            "template": "[![Latest npm version.](https://badge.fury.io/js/PACKAGE.svg)](https://www.npmjs.com/package/PACKAGE) [![NPM package summary.](https://nodei.co/npm/PACKAGE.svg?style=flat&data=n,d,u,s)](https://nodei.co/npm/PACKAGE/) [![Codecov coverage.](https://codecov.io/gh/OWNER/REPO/branch/BRANCH/graph/badge.svg)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![Known vulnerabilities.](https://snyk.io/test/github/OWNER/REPO/badge.svg)](https://snyk.io/test/github/OWNER/REPO) [![Gzipped build size.](https://img.badgesize.com/OWNER/REPO/BRANCH/FILE_PATH?compression=gzip)](https://github.com/OWNER/REPO/blob/BRANCH/FILE_PATH) [![GitHub network dependents.](https://dependents.info/OWNER/REPO/badge)](https://dependents.info/OWNER/REPO)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH",
                "FILE_PATH"
            ],
            "providerBadgeCounts": {
                "badge-fury": 1,
                "nodeico": 1,
                "codecov": 1,
                "snyk": 1,
                "badge-size": 1,
                "dependents-info": 1
            },
            "providers": [
                "badge-fury",
                "nodeico",
                "codecov",
                "snyk",
                "badge-size",
                "dependents-info"
            ],
            "badgeCount": 6
        },
        {
            "id": "alternative-and-provider-native-services-multi-provider-python-package",
            "category": "Alternative and provider-native services",
            "title": "Multi-provider Python package",
            "description": "Keep only services configured for the project; Codecov and Snyk must recognize the public repository.",
            "languages": [
                "Python"
            ],
            "sourceLine": 763,
            "template": "[![Latest PyPI version.](https://badge.fury.io/py/PACKAGE.svg)](https://pypi.org/project/PACKAGE/) [![Monthly PyPI downloads.](https://img.shields.io/pypi/dm/PACKAGE?style=flat&color=BE185D)](https://pypi.org/project/PACKAGE/) [![Supported Python versions.](https://img.shields.io/pypi/pyversions/PACKAGE?style=flat&color=4D7C0F)](https://pypi.org/project/PACKAGE/) [![Codecov coverage.](https://codecov.io/gh/OWNER/REPO/branch/BRANCH/graph/badge.svg)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![Known vulnerabilities.](https://snyk.io/test/github/OWNER/REPO/badge.svg)](https://snyk.io/test/github/OWNER/REPO) [![GitHub network dependents.](https://dependents.info/OWNER/REPO/badge)](https://dependents.info/OWNER/REPO)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "badge-fury": 1,
                "shields": 2,
                "codecov": 1,
                "snyk": 1,
                "dependents-info": 1
            },
            "providers": [
                "badge-fury",
                "shields",
                "codecov",
                "snyk",
                "dependents-info"
            ],
            "badgeCount": 6
        },
        {
            "id": "alternative-and-provider-native-services-playbadges-android-application",
            "category": "Alternative and provider-native services",
            "title": "PlayBadges Android application",
            "description": "APP_ID must be a public Google Play package identifier. Compact PlayBadges rows are more README-friendly than the full app card.",
            "languages": [
                "Java",
                "Kotlin"
            ],
            "sourceLine": 773,
            "template": "[![Google Play downloads.](https://playbadges.pavi2410.com/badge/downloads?id=APP_ID&pretty)](https://play.google.com/store/apps/details?id=APP_ID) [![Google Play rating.](https://playbadges.pavi2410.com/badge/ratings?id=APP_ID&pretty)](https://play.google.com/store/apps/details?id=APP_ID) [![Google Play version.](https://playbadges.pavi2410.com/badge/version?id=APP_ID)](https://play.google.com/store/apps/details?id=APP_ID) [![Latest GitHub release.](https://img.shields.io/github/v/release/OWNER/REPO?style=flat&color=0E7490)](https://github.com/OWNER/REPO/releases/latest) [![GitHub Actions workflow status.](https://img.shields.io/github/actions/workflow/status/OWNER/REPO/WORKFLOW_FILE?branch=BRANCH&style=flat)](https://github.com/OWNER/REPO/actions/workflows/WORKFLOW_FILE)",
            "placeholders": [
                "APP_ID",
                "OWNER",
                "REPO",
                "WORKFLOW_FILE",
                "BRANCH"
            ],
            "providerBadgeCounts": {
                "playbadges": 3,
                "shields": 2
            },
            "providers": [
                "playbadges",
                "shields"
            ],
            "badgeCount": 5
        },
        {
            "id": "alternative-and-provider-native-services-provider-native-project-health-add-ons",
            "category": "Alternative and provider-native services",
            "title": "Provider-native project health add-ons",
            "description": "These badges are intentionally conditional. Use them only when the public service or file is configured and the live preview is meaningful.",
            "languages": [
                "Language agnostic"
            ],
            "sourceLine": 783,
            "template": "[![Codecov coverage.](https://codecov.io/gh/OWNER/REPO/branch/BRANCH/graph/badge.svg)](https://codecov.io/gh/OWNER/REPO/branch/BRANCH) [![Known vulnerabilities.](https://snyk.io/test/github/OWNER/REPO/badge.svg)](https://snyk.io/test/github/OWNER/REPO) [![Public file size.](https://img.badgesize.com/OWNER/REPO/BRANCH/FILE_PATH)](https://github.com/OWNER/REPO/blob/BRANCH/FILE_PATH) [![Gzipped public file size.](https://img.badgesize.com/OWNER/REPO/BRANCH/FILE_PATH?compression=gzip)](https://github.com/OWNER/REPO/blob/BRANCH/FILE_PATH) [![GitHub network dependents.](https://dependents.info/OWNER/REPO/badge)](https://dependents.info/OWNER/REPO)",
            "placeholders": [
                "OWNER",
                "REPO",
                "BRANCH",
                "FILE_PATH"
            ],
            "providerBadgeCounts": {
                "codecov": 1,
                "snyk": 1,
                "badge-size": 2,
                "dependents-info": 1
            },
            "providers": [
                "codecov",
                "snyk",
                "badge-size",
                "dependents-info"
            ],
            "badgeCount": 5
        },
        {
            "id": "conditional-badges-preview-before-keeping-conditional-badges-preview-before-keeping",
            "category": "Conditional badges: preview before keeping",
            "title": "Conditional badges: preview before keeping",
            "description": "These endpoints are official, but their upstream services or package analyzers can fail for an otherwise valid project. Add them one at a time and delete any badge that renders 429, 500, error, unknown, undefined, timeout, or discontinued.",
            "languages": [
                "JavaScript",
                "TypeScript",
                "Python"
            ],
            "sourceLine": 793,
            "template": "[![Minified and gzipped bundle size.](https://flat.badgen.net/bundlejs/minzip/PACKAGE?color=C2410C)](https://bundlejs.com/?q=PACKAGE)\n[![Published package size.](https://flat.badgen.net/packagephobia/publish/PACKAGE?color=475569)](https://packagephobia.com/result?p=PACKAGE)\n[![Installed package size.](https://flat.badgen.net/packagephobia/install/PACKAGE?color=7E22CE)](https://packagephobia.com/result?p=PACKAGE)\n[![Monthly PyPI downloads.](https://flat.badgen.net/pypi/dm/PACKAGE?color=BE185D)](https://pypi.org/project/PACKAGE/)\n[![Coveralls coverage.](https://flat.badgen.net/coveralls/c/github/OWNER/REPO/BRANCH)](https://coveralls.io/github/OWNER/REPO?branch=BRANCH)\n[![DeepScan grade.](https://flat.badgen.net/deepscan/grade/team/DEEPSCAN_TEAM/project/DEEPSCAN_PROJECT/branch/DEEPSCAN_BRANCH)](https://deepscan.io/dashboard/#view=project&tid=DEEPSCAN_TEAM&pid=DEEPSCAN_PROJECT&bid=DEEPSCAN_BRANCH)\n[![XO code style.](https://flat.badgen.net/xo/status/PACKAGE)](https://github.com/xojs/xo)\n[![Tidelift subscription status.](https://flat.badgen.net/tidelift/npm/PACKAGE)](https://www.sonarsource.com/solutions/security/)",
            "placeholders": [
                "PACKAGE",
                "OWNER",
                "REPO",
                "BRANCH",
                "DEEPSCAN_TEAM",
                "DEEPSCAN_PROJECT",
                "DEEPSCAN_BRANCH"
            ],
            "providerBadgeCounts": {
                "badgen": 8
            },
            "providers": [
                "badgen"
            ],
            "badgeCount": 8
        }
    ]
};
